import React, { Component } from "react";

import { Icon } from "@iconify/react";
import QRCode from "react-qr-code";
import ReactPinField from "react-pin-field";

import MobileSubHeader from "../../../components/PageHeader/MobileSubHeader";
import StringInput from "../../../components/Input/StringInput/StringInput";
import NumberInput from "../../../components/Input/NumberInput/NumberInput";
import PasswordInput from "../../../components/Input/PasswordInput/PasswordInput";
import { Link } from "react-router-dom";
export class Authenticator extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSecuriyVerification: false,
      showAuth: true,
    };
  }

  //** COMPONRNT **
  downloadAndInstall = (props) => {
    return (
      <div className="download-install">
        <div className="bg-white p-3 mb-3">
          <h6 className="text-dark">Download Method:</h6>
          <p>1. Scan QR Code</p>

          <div className="auth-qr-container">
            <div className="qr-body">
              <div className="qr-code">
                <QRCode size="100%" value="Apple IOS" />
              </div>
              <button className="btn btn-gradient-blue">
                <Icon icon="uil:apple" />
                Apple IOS
              </button>
            </div>

            <div className="qr-body">
              <div className="qr-code">
                <QRCode size="100%" value="Android" />
              </div>
              <button className="btn btn-gradient-blue">
                <Icon icon="uil:android" />
                Android
              </button>
            </div>
          </div>
        </div>

        <p className="bg-white p-3">
          2. If you cannot download it, you can search for “Google Authenticator” in the Apple Store, <br />
          or search for “Google Authenticator” in the Android App Store to download and install it.
        </p>
        <div className="text-danger d-flex align-items-start my-2 px-3">
          <span style={{ width: "0.75rem", height: "0.75rem" }}>
            <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
          </span>
          <span>Tip: It has been downloaded and installed, click “Next” to continue</span>
        </div>
        <button className="btn btn-gradient-blue mb-3 mx-3" onClick={props.nextStep}>
          Next
        </button>
      </div>
    );
  };

  addSecretCode = (props) => {
    return (
      <div className="secret-code">
        <div className="bg-white p-3">
          <h6 className="text-dark">Scan QR Code or Insert Code Manually:</h6>
          <p>1: Scan QR Code</p>

          <div className="auth-qr-container justify-content-center">
            <div className="qr-body">
              <div className="qr-code">
                <QRCode size="100%" value="Apple IOS" />
              </div>
            </div>
          </div>

          <div className="input-group mb-4">
            <input className="form-control" value={props.secretCode} readOnly />
            <button className="btn btn-gradient-blue" onClick={props.copySecretCode}>
              COPY
            </button>
          </div>

          <h6 className="text-dark">Additional Step:</h6>
          <p>
            Open Google Authenticator, click “+” in the upper right corner (bottom right corner for Android), select
            “Manually enter the key”, fill in any account name insert the secret code as above, you may also scan the QR
            code to add it automatically.
          </p>
        </div>

        <div className="text-danger d-block px-3 mt-2">
          <div className="d-flex align-items-start">
            <span style={{ width: "0.75rem", height: "0.75rem" }}>
              <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
            </span>
            <p>Tips:</p>
          </div>
          <ol className="mb-2">
            <li>
              After the mobile phone is lost or the identity verification is uninstalled, the secret code can help you
              to find the authenticator, please keep it properly.
            </li>
            <li>
              For the safety of your account, please do not indicate the proxy account and proxy background address when
              binding.
            </li>
          </ol>
        </div>

        <div className="d-flex flex-column mb-3 px-3">
          <button className="btn btn-outline-blue mb-2" onClick={props.prevStep}>
            Back
          </button>
          <button className="btn btn-gradient-blue" onClick={props.nextStep}>
            Next
          </button>
        </div>
      </div>
    );
  };

  googleAuth = (props) => {
    return (
      <div className="google-auth">
        <div className="bg-white p-3 ">
          <h6 className="text-dark">Google Authenticator Secret Code</h6>
          <p>Insert 6-Digits Google Authenticator Secret Code</p>

          <div className="input-group mb-3">
            <ReactPinField
              className="pin-field mt-3"
              length="6"
              validate="0123456789"
              type="number"
              value={this.props.googleAuthSecretCode}
              onComplete={this.props.googleAuthSecretCode}
              // ref={this.props.onRef}
            />
          </div>
        </div>

        <div className="text-danger d-block px-3 mt-2">
          <div className="d-flex align-items-start">
            <span style={{ width: "0.75rem", height: "0.75rem" }}>
              <Icon className="me-1" icon="akar-icons:circle-alert-fill" />
            </span>
            <p>Tips:</p>
          </div>
          <ol>
            <li>
              After the mobile phone is lost or the identity verification is uninstalled, the secret code can help you
              to find the authenticator, please keep it properly.
            </li>
            <li>
              For the safety of your account, please do not indicate the proxy account and proxy background address when
              binding.
            </li>
          </ol>
        </div>

        <div className="d-flex flex-column mb-5">
          <button className="btn btn-outline-blue mb-2 mx-3" onClick={props.prevStep}>
            Back
          </button>
          <button className="btn btn-gradient-blue mx-3">Next</button>
        </div>
      </div>
    );
  };

  //** FUNCTION **
  toggleShowAuth = () => {
    this.setState({
      showSecuriyVerification: false,
      showAuth: true,
    });
  };

  imageImport = (r) => {
    let images = {};
    r.keys().map((item, index) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const img = this.imageImport(
      require.context("../../../assets/images/loginregister/", false, /\.(png|jpe?g|svg|webp)$/)
    );

    const steps = [
      { id: 1, label: "Download & Install" },
      { id: 2, label: "Add Secret Code" },
      { id: 3, label: "Enable Google Authenticator" },
    ];
    return (
      <>
        {this.state.showSecuriyVerification && (
          <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto">
            <MobileSubHeader
              className="bg-white"
              closeModalHandler={this.props.backToPersonalDetails}
              header="Edit Payment Password"
              style={{ justifyContent: "unset" }}
            />

            <form className="forms-col needs-validation my-3" onSubmit={this.toggleShowAuth}>
              <div className="pd-form-m-col">
                <div className="input-group-col">
                  <div className="py-2">
                    <label className="col-form-label p-0 m-0">Food</label>
                    <div className="input-group right has-validation pb-3">
                      <StringInput
                        // className={`${this.state.errorMsg.email && "was-validated is-invalid"}`}
                        type="text"
                        placeholder="Please enter secret answer"
                        name="secretAnswer"
                        defaultValue=""
                        value={this.props.securityAns}
                        onChange={(e) => this.props.enterSecurityAns(e)}
                        // emailMessage={t("validation.email")}
                        required
                        // requiredMessage={t("validation.required")}
                        // errorMsg={this.state.errorMsg.email || ""}
                        // formError={this.state.formError}
                      />
                      <span className="input-group-text bg-white" onClick={this.props.toggleRefresh}>
                        <button type="button" className="btn icon p-0">
                          <Icon className="refresh-btn" icon="fe:sync" id="refresh-btn" />
                        </button>
                      </span>
                    </div>
                  </div>

                  <div className="pt-3 border-top">
                    <label className="text-dark">Old Password</label>
                    <div className="input-group right has-validation">
                      <PasswordInput
                        showPwd={this.props.showPassword}
                        onChange={(e) => this.props.enterPaymentPass(e)}
                        id="payment_password"
                        name="payment_password"
                        // className={`no-border form-control ${this.state.errorMsg.newPassword && 'was-validated is-invalid'}`}
                        className={`form-control`}
                        placeholder="Please enter payment password"
                        value={this.props.password}
                        minLength={6}
                        required
                        // requiredMessage={t("validation.required")}
                        // minLengthMessage={t("validation.minLength", { 0: 6 })}
                        // errorMsg={this.state.errorMsg.newPassword || ''}
                        formError={this.state.formError}
                        format={
                          <span className="input-group-text bg-white" onClick={this.props.toggleShowPass}>
                            <button type="button" className="btn icon p-0">
                              {this.props.showPassword ? (
                                <img src={img["eye.png"]} alt="show pwd" />
                              ) : (
                                <img src={img["close-eye.png"]} alt="hide pwd" />
                              )}
                            </button>
                          </span>
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p className="notice-desc px-3" style={{ marginTop: "-0.5rem" }}>
                For your account security, please perform security verification first.
              </p>
              <div className="d-flex flex-column">
                <Link
                  className="btn btn-outline-blue mx-3 mb-2 d-flex align-items-center justify-content-center"
                  to={{ pathname: "/" }}
                  // disabled
                  // disabled={!this.props.currentMobileNo || (this.props.sms_otp_code.length < 6 && "active")}
                  onClick={this.props.backToPersonalDetails}
                >
                  Joint Venture Consultation
                </Link>
                <button
                  className="btn btn-gradient-blue mx-3"
                  type="submit"
                  // disabled
                  // disabled={!this.props.currentMobileNo || (this.props.sms_otp_code.length < 6 && "active")}
                >
                  Submit
                </button>
              </div>
            </form>
          </section>
        )}

        {this.state.showAuth && (
          <section className="verification-m-section pf-m-dashboard on-top d-block pe-auto">
            <MobileSubHeader
              className="bg-white"
              closeModalHandler={this.props.backToPersonalDetails}
              header="Binding Authenticator"
              style={{ justifyContent: "unset" }}
            />

            <div className="auth-container">
              <div className="step-progress-bar my-5 mx-3">
                {steps &&
                  steps.map((item, index) => (
                    <>
                      <div
                        key={index}
                        className={`step ${
                          item.id < this.props.currentStep
                            ? "completed"
                            : item.id === this.props.currentStep
                            ? "active"
                            : ""
                        }`}
                      >
                        {item.id < this.props.currentStep ? (
                          <p className="step-done">
                            <Icon icon="ic:baseline-check" />
                          </p>
                        ) : (
                          <p className="step-num">{item.id}</p>
                        )}
                        <p className="step-title">{item.label}</p>
                      </div>

                      {index + 1 !== steps.length && (
                        <hr className={`${item.id < this.props.currentStep && "active"}`} />
                      )}
                    </>
                  ))}
              </div>
              {this.props.currentStep === 1 ? (
                <this.downloadAndInstall {...this.props} />
              ) : this.props.currentStep === 2 ? (
                <this.addSecretCode {...this.props} />
              ) : (
                <this.googleAuth {...this.props} />
              )}
            </div>
          </section>
        )}
      </>
    );
  }
}

export default Authenticator;
